import { Box } from '@chakra-ui/react'
import SponsorTable from './components/SponsorTable'

export default function User () {
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <SponsorTable />
    </Box>
  )
}
